module.exports = __webpack_public_path__ + "static/media/dots-grid.2ff4964d.svg";